'use client';

import * as layout from '@ocodelib/compose-layout';
import { FlexColumn } from '@ocodelib/mui';
import { useBehaviorSubject } from '@ocodelib/mui/hooks';
import clsx from 'clsx';
import { ContentTabs } from '../components/ContentTabs';
import { useJsBasicApp } from '../useJsBasicApp';
import { PLUGIN_KEYS, PLUGIN_KIND_CONTENT, PLUGIN_KIND_HIDDEN } from './plugin-keys';

interface Props {
  className?: string;
}

export function LayoutRoot(props: Props) {
  const { className } = props;
  const { appManager } = useJsBasicApp();
  const currentTabKey = useBehaviorSubject(appManager.uiState.currentContentTab$);
  const preview = useBehaviorSubject(appManager.uiState.previewMode$);

  return (
    <FlexColumn
      alignItems="stretch"
      className={clsx('LayoutRoot-root', className)}
      sx={{
        maxHeight: '100dvh',
        height: '100dvh',
        minWidth: 800,
        bgcolor: '#f1f4f8',
        '& > .LayoutRoot-content': {
          flex: 1,
        },
      }}
    >
      {/* 프리뷰모드에서는 Topbar를 감춘다 */}
      {!preview && <layout.PluginSlot plugin={PLUGIN_KEYS.root.topBar} />}

      {/* 프리뷰모드에서는 컨텐트탭을 감춘다 */}
      {!preview && <ContentTabs />}

      <layout.PluginSelectableSlot
        className="LayoutRoot-content"
        pluginKind={PLUGIN_KIND_CONTENT}
        selectedPluginName={currentTabKey ?? ''}
      />
      <layout.PluginsSlot pluginKind={PLUGIN_KIND_HIDDEN} />
    </FlexColumn>
  );
}
